var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full bg-gray-50 flex"},[_c('SidebarNav'),_c('div',{staticClass:"flex-1"},[_c('HeaderNav'),_c('div',{staticClass:"py-4 px-8"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }